var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReservationBlue24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-reservation-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 221",
    d: "M5.50011 2.49967H4.50006C3.3955 2.49967 2.50008 3.39508 2.50006 4.49964L2.5 7.5M5.50011 2.49967V1.5M5.50011 2.49967H18.5001M5.50011 2.49967V4.5M18.5001 2.49967H19.5001C20.6047 2.49967 21.5001 3.39512 21.5001 4.49971L21.5 7.5M18.5001 2.49967V1.5M18.5001 2.49967V4.5M2.5 7.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H19.5C20.6046 21.5 21.5 20.6046 21.5 19.5V7.5M2.5 7.5H21.5",
    stroke: "#286BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 107",
    x: 10,
    y: 12,
    width: 5,
    height: 1,
    rx: 0.5,
    fill: "#286BB7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 108",
    x: 10,
    y: 10,
    width: 9,
    height: 1,
    rx: 0.5,
    fill: "#286BB7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 109",
    x: 10,
    y: 15,
    width: 8,
    height: 1,
    rx: 0.5,
    fill: "#286BB7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 110",
    x: 10,
    y: 17,
    width: 4,
    height: 1,
    rx: 0.5,
    fill: "#286BB7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 226",
    d: "M5.5 13.5V10.5H8.5V13.5H5.5Z",
    stroke: "#286BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 227",
    d: "M5.5 18.5001V15.5L8.5 15.5V18.5L5.5 18.5001Z",
    stroke: "#286BB7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReservationBlue24);
export default __webpack_public_path__ + "static/media/icon-reservation-blue-24.d5e218477c75867c1312b65e7af9ce69.svg";
export { ForwardRef as ReactComponent };